import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'no-comments',
  templateUrl: 'no-comments.component.html',
  styleUrls: ['no-comments.component.scss'],
})
export class NoCommentsComponent {}
